module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/banner.35edb963.png";